<template>
  <section class="business-page">
    <div class="page-head business-head">
      <div>
        <h2>{{ page.title }}</h2>
        <p>{{ page.description }}</p>
      </div>
      <div class="head-actions">
        <el-button
          v-if="page.exportable"
          icon="el-icon-download"
          @click="exportData"
          >导出当前结果</el-button
        ><el-button
          v-if="moduleKey !== 'feedbacks' && page.addText && page.form.length"
          type="success"
          :icon="page.addIcon || 'el-icon-plus'"
          @click="openForm('add')"
          >{{ page.addText }}</el-button
        >
      </div>
    </div>
    <div
      v-if="dynamicStats.length"
      class="business-stats"
      :class="`stats-${dynamicStats.length}`"
    >
      <article
        v-for="item in dynamicStats"
        :key="item.label"
        :class="{ attention: item.attention }"
      >
        <i :class="item.icon" />
        <div>
          <small>{{ item.label }}</small
          ><strong>{{ item.value }}</strong
          ><span>{{ item.desc }}</span>
        </div>
      </article>
    </div>
    <el-card class="filter-card" shadow="never"
      ><el-form :inline="true" :model="filters" size="small"
        ><el-form-item
          v-for="field in page.filters"
          :key="field.key"
          :label="field.label"
          :required="field.required"
          ><el-input
            v-if="field.type === 'input'"
            v-model="filters[field.key]"
            :placeholder="field.placeholder"
            clearable /><el-input-number
            v-else-if="field.type === 'number'"
            v-model="filters[field.key]"
            :min="1"
            controls-position="right" /><el-select
            v-else-if="field.type === 'select'"
            v-model="filters[field.key]"
            :placeholder="field.placeholder"
            clearable
            ><el-option
              v-for="option in field.options"
              :key="option.value || option"
              :label="option.label || option"
              :value="
                option.value === undefined ? option : option.value
              " /></el-select
          ><el-date-picker
            v-else
            v-model="filters[field.key]"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期" /></el-form-item
        ><el-form-item class="filter-actions"
          ><el-button icon="el-icon-refresh" @click="resetFilters"
            >重置</el-button
          ><el-button type="success" icon="el-icon-search" @click="search"
            >查询</el-button
          ></el-form-item
        ></el-form
      ></el-card
    >
    <template v-if="page.classCards"
      ><div v-loading="loading" class="class-grid-vue">
        <article v-for="item in rows" :key="item.id" class="class-card-vue">
          <header>
            <div>
              <h3>{{ item.name }}</h3>
              <p>
                <i class="el-icon-user" />
                {{ item.teacher || "未分配" }}（负责老师）
              </p>
            </div>
            <el-dropdown @command="(command) => classCommand(command, item)"
              ><el-button type="text" icon="el-icon-more" /><el-dropdown-menu
                slot="dropdown"
                ><el-dropdown-item command="edit">编辑班级</el-dropdown-item
                ><el-dropdown-item
                  v-if="item.status !== 'disabled'"
                  command="disable"
                  >停用班级</el-dropdown-item
                ><el-dropdown-item command="delete" divided>删除班级</el-dropdown-item
                ></el-dropdown-menu
              ></el-dropdown
            >
          </header>
          <div class="class-meta">
            <span
              ><b>{{ item.students }}</b> / {{ item.capacity }} 名学生</span
            ><span>容量 {{ item.students }}/{{ item.capacity }}</span>
          </div>
          <div class="class-progress">
            <div>
              <span>今日考勤状态</span
              ><b :class="{ warning: item.rate < 80 }"
                >{{ item.arrived }} / {{ item.students }}
                {{
                  item.rate >= 95 ? "全勤" : item.rate < 80 ? "异常" : "已到"
                }}</b
              >
            </div>
            <el-progress
              :percentage="item.rate"
              :color="item.rate < 80 ? '#ba1a1a' : '#448154'"
              :show-text="false"
            />
          </div>
          <footer>
            <el-button
              type="success"
              icon="el-icon-date"
              @click="
                $router.push({
                  path: '/attendance',
                  query: { classId: item.id },
                })
              "
              >进入考勤</el-button
            ><el-button icon="el-icon-edit" @click="openForm('edit', item)"
              >编辑班级</el-button
            ><el-button
              type="text"
              icon="el-icon-user-solid"
              @click="
                $router.push({ path: '/students', query: { classId: item.id } })
              "
              >查看学生</el-button
            >
          </footer>
        </article>
        <button class="class-add-vue" @click="openForm('add')">
          <i class="el-icon-circle-plus-outline" /><b>新增班级</b
          ><small>设置教学小组与分配负责老师</small>
        </button>
      </div>
      <div class="pagination-bar class-pagination">
        <span>共 {{ pagination.total }} 个班级</span
        ><el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          :current-page="pagination.page"
          @current-change="changePage"
        /></div
    ></template>
    <el-card v-else class="table-card" shadow="never"
      ><div class="table-toolbar">
        <div>
          <el-button
            v-if="moduleKey === 'feedbacks'"
            icon="el-icon-message"
            @click="batchSend"
            >批量发送家长</el-button
          ><el-button
            v-if="moduleKey === 'students'"
            icon="el-icon-date"
            :disabled="!selection.length"
            @click="adjustRemainingDays(selection)"
            >批量调整天数</el-button
          ><el-button
            v-if="moduleKey === 'students'"
            icon="el-icon-document-delete"
            :disabled="!selection.length"
            @click="batchLeaveStudents"
            >批量请假</el-button
          >
        </div>
        <span
          >共 <b>{{ pagination.total }}</b> 条记录</span
        >
      </div>
      <el-table
        v-loading="loading"
        :data="rows"
        stripe
        style="width: 100%"
        empty-text="暂无符合条件的数据"
        :row-class-name="tableRowClassName"
        @selection-change="selection = $event"
        ><el-table-column
          v-if="page.selectable"
          type="selection"
          width="44"
        /><el-table-column
          v-for="column in page.columns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :min-width="column.width || 110"
          show-overflow-tooltip
          ><template slot-scope="scope"
            ><div v-if="column.avatar" class="person-cell-vue">
              <el-avatar :size="32">{{
                (scope.row[column.prop] || "学").slice(0, 1)
              }}</el-avatar
              ><b>{{ scope.row[column.prop] || "--" }}</b>
            </div>
            <el-tag
              v-else-if="column.status"
              size="mini"
              :type="statusType(scope.row[column.prop])"
              >{{ scope.row[column.prop] || "--" }}</el-tag
            >
            <div v-else-if="column.progress" class="progress-vue">
              <el-progress
                :percentage="scope.row[column.prop]"
                color="#448154"
              /><span>{{ scope.row[column.prop] }}%</span>
            </div>
            <strong v-else-if="column.money">{{
              scope.row[column.prop]
            }}</strong
            ><span
              v-else-if="column.remainingDays"
              :class="{ 'remaining-days-warning': scope.row.remainingDays < 5 }"
              >{{ scope.row[column.prop] }}</span
            ><span v-else>{{ scope.row[column.prop] || "--" }}</span></template
          ></el-table-column
        ><el-table-column
          v-if="page.actionWidth !== 0"
          label="操作"
          :width="page.actionWidth || 220"
          fixed="right"
          ><template slot-scope="scope"
            ><div class="row-actions">
              <el-button
                v-if="moduleKey === 'students'"
                type="text"
                icon="el-icon-view"
                @click="$router.push(`/students/${scope.row.id}`)"
                >详情</el-button
              ><el-button
                v-if="moduleKey === 'students'"
                type="text"
                icon="el-icon-circle-plus-outline"
                @click="adjustPoints(scope.row, 1)"
                >加分</el-button
              ><el-button
                v-if="moduleKey === 'students'"
                type="text"
                icon="el-icon-remove-outline"
                @click="adjustPoints(scope.row, -1)"
                >减分</el-button
              ><el-button
                v-if="moduleKey === 'students'"
                type="text"
                icon="el-icon-date"
                @click="adjustRemainingDays([scope.row])"
                >调整天数</el-button
              ><el-button
                v-if="canSendCareDayReminder(scope.row)"
                type="text"
                icon="el-icon-message"
                @click="sendCareDayReminder(scope.row)"
                >发送通知</el-button
              ><el-button
                v-if="moduleKey === 'leaves' && scope.row.status === 'pending'"
                type="text"
                icon="el-icon-circle-check"
                @click="review(scope.row, 'approved')"
                >通过</el-button
              ><el-button
                v-if="moduleKey === 'leaves' && scope.row.status === 'pending'"
                class="danger-text"
                type="text"
                icon="el-icon-circle-close"
                @click="review(scope.row, 'rejected')"
                >拒绝</el-button
              ><el-button
                v-if="moduleKey === 'leaves' && ['pending', 'approved'].includes(scope.row.status)"
                class="danger-text"
                type="text"
                icon="el-icon-refresh-left"
                @click="cancelLeaveRow(scope.row)"
                >撤销</el-button
              ><el-button
                v-if="
                  moduleKey === 'attendance' &&
                  scope.row.status === 'not_arrived'
                "
                type="text"
                icon="el-icon-circle-check"
                @click="attendance(scope.row, 'checked_in')"
                >签到</el-button
              ><el-button
                v-if="
                  moduleKey === 'attendance' &&
                  scope.row.status === 'not_arrived'
                "
                type="text"
                icon="el-icon-document-delete"
                @click="markLeave(scope.row)"
                >请假</el-button
              ><el-button
                v-if="moduleKey === 'attendance' && scope.row.pickupCardUrl"
                type="text"
                icon="el-icon-picture-outline"
                @click="viewPickupCard(scope.row)"
                >接送卡</el-button
              ><el-button
                v-if="
                  moduleKey === 'payments' &&
                  ['pending', 'overdue'].includes(scope.row.status)
                "
                type="text"
                icon="el-icon-money"
                @click="confirmPaymentRow(scope.row)"
                >确认收款</el-button
              ><el-button
                v-if="moduleKey === 'notices'"
                type="text"
                icon="el-icon-view"
                @click="openDetail(scope.row)"
                >查看</el-button
              ><el-button
                v-if="moduleKey === 'notices' && scope.row.status === 'draft'"
                type="text"
                icon="el-icon-position"
                @click="publishNoticeRow(scope.row)"
                >发布</el-button
              ><el-button
                v-if="moduleKey === 'feedbacks'"
                type="text"
                icon="el-icon-view"
                @click="openDetail(scope.row)"
                >查看</el-button
              ><el-button
                v-if="moduleKey === 'feedbacks'"
                type="text"
                icon="el-icon-edit-outline"
                @click="openForm('edit', scope.row)"
                >{{ scope.row.published ? "编辑反馈" : "填写反馈" }}</el-button
              ><el-button
                v-if="
                  !['leaves', 'attendance', 'feedbacks'].includes(moduleKey)
                "
                type="text"
                icon="el-icon-edit"
                @click="openForm('edit', scope.row)"
                >编辑</el-button
              ><el-button
                v-if="moduleKey === 'students' && scope.row.status === 'active' && scope.row.remainingDays <= 0"
                class="danger-text"
                type="text"
                icon="el-icon-remove-outline"
                @click="dangerAction(scope.row, '停托')"
                >停托</el-button
              ><el-button
                v-if="moduleKey === 'students' && scope.row.status === 'suspended'"
                type="text"
                icon="el-icon-refresh-right"
                @click="restoreStudent(scope.row)"
                >复托</el-button
              ><el-button
                v-if="
                  moduleKey === 'notices' && scope.row.status === 'published'
                "
                class="danger-text"
                type="text"
                icon="el-icon-refresh-left"
                @click="dangerAction(scope.row, '撤回')"
                >撤回</el-button
              ><el-button
                v-if="moduleKey === 'users'"
                :class="scope.row.status === 'active' ? 'danger-text' : ''"
                type="text"
                icon="el-icon-switch-button"
                @click="toggleUser(scope.row)"
                >{{
                  scope.row.status === "active" ? "禁用" : "启用"
                }}</el-button
              ><el-button
                v-if="moduleKey === 'users'"
                type="text"
                icon="el-icon-key"
                @click="resetPassword(scope.row)"
                >重置密码</el-button
              ><el-button
                v-if="['students', 'users'].includes(moduleKey)"
                class="danger-text"
                type="text"
                icon="el-icon-delete"
                @click="deleteRow(scope.row)"
                >删除</el-button
              ><el-button
                v-if="
                  moduleKey === 'payments' &&
                  ['pending', 'overdue'].includes(scope.row.status)
                "
                class="danger-text"
                type="text"
                icon="el-icon-close"
                @click="cancelPaymentRow(scope.row)"
                >取消</el-button
              ><el-button
                v-if="moduleKey === 'payments' && scope.row.status === 'paid'"
                class="danger-text"
                type="text"
                icon="el-icon-refresh-left"
                @click="refundPaymentRow(scope.row)"
                >退款</el-button
              >
            </div></template
          ></el-table-column
        ></el-table
      >
      <div class="pagination-bar">
        <span>{{
          pagination.total
            ? `显示第 ${
                (pagination.page - 1) * pagination.pageSize + 1
              } - ${Math.min(
                pagination.page * pagination.pageSize,
                pagination.total
              )} 条`
            : "暂无记录"
        }}</span
        ><el-pagination
          background
          layout="prev, pager, next, sizes"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          :current-page="pagination.page"
          :page-sizes="moduleKey === 'operationLogs' ? [10, 20, 50, 100] : [5, 10, 20]"
          @current-change="changePage"
          @size-change="changePageSize"
        /></div
    ></el-card>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="680px"
      append-to-body
      ><el-form :model="editForm" label-width="96px"
        ><el-form-item
          v-for="field in visibleFormFields"
          :key="field.key"
          :label="field.label"
          :required="field.required"
          ><el-input
            v-if="
              ![
                'select',
                'multi-select',
                'radio',
                'textarea',
                'date',
                'number',
              ].includes(field.type)
            "
            v-model="editForm[field.key]"
            :placeholder="`请输入${field.label}`" /><el-input-number
            v-else-if="field.type === 'number'"
            v-model="editForm[field.key]"
            :min="field.key === 'remainingDays' ? 0 : (field.min === undefined ? 1 : field.min)"
            :disabled="field.key === 'remainingDays' && editMode === 'edit'"
            controls-position="right" /><el-date-picker
            v-else-if="field.type === 'date'"
            v-model="editForm[field.key]"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期" /><el-input
            v-else-if="field.type === 'textarea'"
            v-model="editForm[field.key]"
            type="textarea"
            :rows="4" /><el-radio-group
            v-else-if="field.type === 'radio'"
            v-model="editForm[field.key]"
            ><el-radio
              v-for="option in field.options"
              :key="String(option.value === undefined ? option : option.value)"
              :label="option.value === undefined ? option : option.value"
              >{{ option.label || option }}</el-radio
            ></el-radio-group
          ><el-select
            v-else
            v-model="editForm[field.key]"
            :multiple="field.type === 'multi-select'"
            collapse-tags
            style="width: 100%"
            ><el-option
              v-for="option in field.options"
              :key="String(option.value === undefined ? option : option.value)"
              :label="option.label || option"
              :value="
                option.value === undefined ? option : option.value
              " /></el-select></el-form-item></el-form
      ><section v-if="moduleKey === 'feedbacks' && editMode === 'edit'" class="feedback-editor">
        <h3>学科作业</h3>
        <el-empty v-if="!editForm.homeworkItems || !editForm.homeworkItems.length" description="当日暂无作业登记" :image-size="64" />
        <article v-for="(subject, subjectIndex) in editForm.homeworkItems || []" :key="`${subject.subject}-${subjectIndex}`" class="feedback-subject">
          <header><b>{{ subject.subject }}</b><span>{{ (subject.contents || []).length }} 项</span></header>
          <div v-for="(task, taskIndex) in subject.contents || []" :key="taskIndex" class="feedback-edit-homework-row">
            <span class="homework-content">{{ taskIndex + 1 }}. {{ task.content }}</span>
            <el-checkbox :value="Boolean(task.checked)" @change="value => setFeedbackTaskChecked(subjectIndex, taskIndex, value)">师查</el-checkbox>
            <el-radio-group :value="task.completionStatus" size="mini" @input="value => setFeedbackTaskCompletion(subjectIndex, taskIndex, value)"><el-radio-button label="completed">已完成</el-radio-button><el-radio-button label="unfinished">未完成</el-radio-button></el-radio-group>
          </div>
          <el-input :value="subject.comment" type="textarea" :rows="2" :placeholder="`${subject.subject}学科评语`" @input="value => setFeedbackSubjectComment(subjectIndex, value)" />
        </article>
      </section><span slot="footer"
        ><el-button @click="dialogVisible = false">取消</el-button
        ><el-button type="success" :loading="submitting" @click="submitForm"
          >保存</el-button
        ></span
      ></el-dialog
    >
    <el-drawer
      v-if="moduleKey === 'feedbacks'"
      :title="`${detailRow.studentName || '学生'}的作业反馈`"
      :visible.sync="detailVisible"
      size="640px"
      custom-class="feedback-detail-drawer"
    >
      <div v-loading="detailLoading" class="feedback-detail">
        <div class="feedback-detail-meta">
          <span
            ><small>反馈日期</small><b>{{ detailRow.date || "--" }}</b></span
          ><span
            ><small>所在班级</small
            ><b>{{ detailRow.className || "--" }}</b></span
          ><span
            ><small>反馈老师</small
            ><b>{{ detailRow.teacherName || "--" }}</b></span
          ><span
            ><small>发布状态</small
            ><el-tag
              size="mini"
              :type="detailRow.published ? 'success' : 'warning'"
              >{{ detailRow.published ? "已反馈" : "待反馈" }}</el-tag
            ></span
          >
        </div>
        <section class="feedback-detail-section">
          <h3>作业评价</h3>
          <div class="feedback-evaluation-grid">
            <div v-for="field in feedbackEvaluationFields" :key="field.key">
              <small>{{ field.label }}</small
              ><b>{{ detailRow[field.key] || "--" }}</b>
            </div>
          </div>
        </section>
        <section class="feedback-detail-section">
          <h3>学科作业</h3>
          <el-empty
            v-if="!detailRow.homeworkItems || !detailRow.homeworkItems.length"
            description="当日暂无作业登记"
            :image-size="72"
          />
          <article
            v-for="(subject, index) in detailRow.homeworkItems || []"
            :key="`${subject.subject}-${index}`"
            class="feedback-subject"
          >
            <header>
              <b>{{ subject.subject }}</b
              ><span>{{ (subject.contents || []).length }} 项</span>
            </header>
            <div
              v-for="(task, taskIndex) in subject.contents || []"
              :key="taskIndex"
              class="feedback-homework-row"
            >
              <span class="homework-content"
                >{{ taskIndex + 1 }}. {{ task.content }}</span
              ><el-tag size="mini" :type="task.checked ? 'success' : 'info'">{{
                task.checked ? "已师查" : "未师查"
              }}</el-tag
              ><el-tag
                size="mini"
                :type="
                  task.completionStatus === 'completed'
                    ? 'success'
                    : task.completionStatus === 'unfinished'
                    ? 'danger'
                    : 'info'
                "
                >{{
                  task.completionStatus === "completed"
                    ? "已完成"
                    : task.completionStatus === "unfinished"
                    ? "未完成"
                    : "未选择"
                }}</el-tag
              >
            </div>
            <div class="subject-comment">
              <small>学科评语</small>
              <p>{{ subject.comment || "暂无学科评语" }}</p>
            </div>
          </article>
        </section>
        <section class="feedback-detail-section">
          <h3>老师总评</h3>
          <p class="teacher-comment">
            {{ detailRow.comment || "暂无老师总评" }}
          </p>
        </section>
      </div>
    </el-drawer>
    <el-drawer
      v-else
      :title="detailRow.title || detailRow.name || '详情'"
      :visible.sync="detailVisible"
      size="420px"
      ><div class="drawer-detail">
        <p v-for="column in page.columns" :key="column.prop">
          <span>{{ column.label }}</span
          ><b>{{ detailRow[column.prop] || "--" }}</b>
        </p>
      </div></el-drawer
    >
    <el-dialog
      title="查看接送卡"
      :visible.sync="pickupCardVisible"
      width="420px"
      append-to-body
      ><el-image
        v-if="pickupCardUrl"
        :src="pickupCardUrl"
        fit="contain"
        :preview-src-list="[pickupCardUrl]" /><el-empty
        v-else
        description="暂无接送卡"
    /></el-dialog>
  </section>
</template>

<script>
import { getBusinessPage } from "../../config/business-pages";
import {
  listStudents,
  createStudent,
  updateStudent,
  updateStudentStatus,
  adjustStudentPoints,
  adjustStudentRemainingDays,
  deleteStudent,
  sendStudentCareDayReminder,
} from "../../api/students";
import { listClasses, createClass, updateClass, deleteClass } from "../../api/classes";
import {
  listAttendance,
  checkIn,
  batchCheckIn,
  updateAttendance,
  createAttendance,
} from "../../api/attendance";
import {
  listLeaves,
  createLeave,
  approveLeave,
  rejectLeave,
  cancelLeave,
} from "../../api/leaves";
import {
  listFeedbacks,
  getFeedback,
  saveFeedback,
  publishFeedback,
  listNotices,
  saveNotice,
  publishNotice,
  revokeNotice,
  listPayments,
  savePayment,
  confirmPayment,
  cancelPayment,
  refundPayment,
  listUsers,
  saveUser,
  updateUserStatus,
  resetUserPassword,
  deleteUser,
} from "../../api/operations";
import { listOperationLogs } from "../../api/operation-logs";
import { STATUS, ROLE_LABELS, typeOfStatus } from "../../constants/status";
import { formatMoney, formatTime, toCents } from "../../utils/format";

const statusText = (group, value) => STATUS[group]?.[value] || value || "--";
const apiList = {
  students: listStudents,
  classes: listClasses,
  attendance: listAttendance,
  leaves: listLeaves,
  feedbacks: listFeedbacks,
  notices: listNotices,
  payments: listPayments,
  users: listUsers,
  operationLogs: listOperationLogs,
};
const operationActionLabels = {
  student_care_day_auto_deduct: "自动扣除晚托天数",
  student_remaining_days_adjust: "调整剩余天数",
  student_pickup_record_cancel: "取消接送记录",
  student_points_adjust: "调整学生积分",
  students_delete: "删除学生",
  classes_delete: "删除班级",
  users_delete: "删除员工",
};
const resourceTypeLabels = {
  student: "学生",
  students: "学生管理",
  classes: "班级管理",
  users: "员工管理",
  leave: "请假审批",
  notice: "通知公告",
};
const feedbackEvaluationFields = [
  { key: "disciplineLevel", label: "纪律" },
  { key: "accuracy", label: "正确率" },
  { key: "speed", label: "速度" },
  { key: "handwriting", label: "字迹" },
  { key: "homeworkRegistration", label: "作业登记" },
  { key: "reviewExtension", label: "复习拓展" },
];

export default {
  name: "BusinessPage",
  props: { moduleKey: { type: String, required: true } },
  data: () => ({
    rows: [],
    filters: {},
    lookups: { students: [], classes: [], teachers: [] },
    loading: false,
    detailLoading: false,
    pageNo: 1,
    pageSize: 10,
    total: 0,
    summary: {},
    pagination: { page: 1, pageSize: 10, total: 0, totalPages: 0 },
    selection: [],
    dialogVisible: false,
    detailVisible: false,
    pickupCardVisible: false,
    pickupCardUrl: "",
    submitting: false,
    editMode: "add",
    editForm: {},
    detailRow: {},
    feedbackEvaluationFields,
  }),
  computed: {
    page() {
      return getBusinessPage(this.moduleKey, this.lookups);
    },
    filteredRows() {
      return this.rows;
    },
    pagedRows() {
      return this.rows;
    },
    visibleFormFields() {
      return this.page.form.filter(
        (field) => !field.when || field.when(this.editForm)
      );
    },
    dialogTitle() {
      return `${
        this.editMode === "add" ? "新增" : "编辑"
      }${this.page.title.replace("中心", "")}`;
    },
    dynamicStats() {
      const rows = this.rows;
      if (this.moduleKey === "attendance") {
        const checked = Number(this.summary.checkedIn || 0);
        const expected = Number(this.summary.expected || 0);
        return [
          {
            label: "应到人数",
            value: expected,
            desc: "筛选日期在托学生",
            icon: "el-icon-user-solid",
          },
          {
            label: "已签到",
            value: checked,
            desc: `${
              expected ? Math.round((checked / expected) * 100) : 0
            }% 出勤率`,
            icon: "el-icon-circle-check",
          },
          {
            label: "未签到",
            value: Number(this.summary.notArrived || 0),
            desc: "需要关注",
            icon: "el-icon-time",
            attention: true,
          },
          {
            label: "请假",
            value: Number(this.summary.leave || 0),
            desc: "已同步审批",
            icon: "el-icon-document-delete",
          },
        ];
      }
      if (this.moduleKey === "leaves")
        return [
          {
            label: "待审批",
            value: Number(this.summary.pending || 0),
            desc: "需要及时处理",
            icon: "el-icon-time",
            attention: true,
          },
          {
            label: "已处理",
            value: Number(this.summary.processed || 0),
            desc: "累计已处理",
            icon: "el-icon-circle-check",
          },
        ];
      if (this.moduleKey === "feedbacks")
        return [
          {
            label: "反馈记录",
            value: Number(this.summary.total || 0),
            desc: "当前查询范围",
            icon: "el-icon-document",
          },
          {
            label: "已反馈",
            value: Number(this.summary.published || 0),
            desc: "已发布给家长",
            icon: "el-icon-circle-check",
          },
          {
            label: "待反馈",
            value: Number(this.summary.pending || 0),
            desc: "需要完成",
            icon: "el-icon-warning-outline",
            attention: true,
          },
        ];
      if (this.moduleKey === "notices")
        return [
          {
            label: "已发布",
            value: Number(this.summary.published || 0),
            desc: "当前已发布",
            icon: "el-icon-bell",
          },
          {
            label: "累计阅读",
            value: Number(this.summary.readCount || 0),
            desc: "通知阅读量",
            icon: "el-icon-view",
          },
          {
            label: "草稿",
            value: Number(this.summary.draft || 0),
            desc: "待发布",
            icon: "el-icon-message",
          },
        ];
      if (this.moduleKey === "payments") {
        const receivable = rows.reduce(
          (sum, row) => sum + Number(row.receivableAmount || 0),
          0
        );
        const received = rows.reduce(
          (sum, row) => sum + Number(row.receivedAmount || 0),
          0
        );
        return [
          {
            label: "应收金额",
            value: formatMoney(receivable),
            desc: "当前查询范围",
            icon: "el-icon-document",
          },
          {
            label: "实收金额",
            value: formatMoney(received),
            desc: "当前查询范围",
            icon: "el-icon-circle-check",
          },
          {
            label: "待收金额",
            value: formatMoney(Math.max(receivable - received, 0)),
            desc: "待处理",
            icon: "el-icon-warning-outline",
            attention: true,
          },
        ];
      }
      if (this.moduleKey === "users")
        return [
          {
            label: "在职员工",
            value: Number(this.summary.active || 0),
            desc: "当前启用账号",
            icon: "el-icon-s-custom",
          },
          {
            label: "老师",
            value: Number(this.summary.teachers || 0),
            desc: "教学岗位",
            icon: "el-icon-school",
          },
          {
            label: "管理人员",
            value: Number(this.summary.managers || 0),
            desc: "机构管理岗位",
            icon: "el-icon-key",
          },
        ];
      return [];
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.pageNo = 1;
      },
    },
  },
  created() {
    this.load();
  },
  methods: {
    async loadLookups() {
      const fields = [...this.page.filters, ...this.page.form];
      const needStudents = fields.some((field) => field.lookup === "students");
      const needClasses = fields.some((field) => field.lookup === "classes");
      const needTeachers = fields.some((field) => field.lookup === "teachers");
      const requests = [];
      if (needStudents)
        requests.push({
          key: "students",
          request: listStudents({ page: 1, pageSize: 1000 }),
        });
      if (needClasses)
        requests.push({
          key: "classes",
          request: listClasses({ page: 1, pageSize: 1000 }),
        });
      if (needTeachers)
        requests.push({
          key: "teachers",
          request: listUsers({ page: 1, pageSize: 1000 }),
        });
      const results = await Promise.allSettled(
        requests.map((item) => item.request)
      );
      const lookups = { ...this.lookups };
      let failed = false;
      results.forEach((result, index) => {
        if (result.status === "rejected") {
          failed = true;
          return;
        }
        const key = requests[index].key;
        const rows = result.value?.list || [];
        lookups[key] =
          key === "teachers"
            ? rows.filter(
                (item) => item.role === "teacher" && item.status === "active"
              )
            : rows;
      });
      this.lookups = lookups;
      if (failed)
        this.$message.warning("部分筛选选项加载失败，列表数据仍可正常查看");
    },
    createFilters() {
      return this.page.filters.reduce((result, field) => {
        result[field.key] =
          typeof field.defaultValue === "function"
            ? field.defaultValue()
            : field.defaultValue ?? "";
        return result;
      }, {});
    },
    async load() {
      this.loading = true;
      try {
        await this.loadLookups();
        if (!Object.keys(this.filters).length) {
          this.filters = this.createFilters();
          if (this.$route.query.classId)
            this.filters.classId = this.$route.query.classId;
          if (this.$route.query.keyword)
            this.filters.keyword = this.$route.query.keyword;
        }
        const result = await apiList[this.moduleKey]({
          ...this.filters,
          page: this.pageNo,
          pageSize: this.pageSize,
        });
        this.rows = this.normalizeRows(result?.list || []);
        this.summary = result?.summary || { total: result?.pagination?.total || 0 };
        this.pagination = result?.pagination || {
          page: this.pageNo,
          pageSize: this.pageSize,
          total: this.rows.length,
          totalPages: 1,
        };
        this.total = this.pagination.total;
      } catch (error) {
        this.rows = [];
        this.pagination = {
          page: 1,
          pageSize: this.pageSize,
          total: 0,
          totalPages: 0,
        };
        this.total = 0;
        this.summary = {};
        this.$message.error(
          error.userMessage || "数据加载失败，请检查后端服务"
        );
      } finally {
        this.loading = false;
      }
    },
    normalizeRows(rows) {
      return rows.map((row) => {
        const item = { ...row };
        if (this.moduleKey === "students") {
          item.genderLabel =
            item.gender === "male"
              ? "男"
              : item.gender === "female"
              ? "女"
              : "--";
          item.statusLabel = statusText("student", item.status);
          item.guardian = item.primaryParentName || "--";
          item.phone = item.primaryParentPhone || "--";
          item.pointsLabel = `${Number(item.points || 0)} 分`;
          item.remainingDays = Number(item.remainingDays || 0);
          item.remainingDaysLabel = `${item.remainingDays} 天`;
          item.lastCareReminderLabel = item.lastCareReminderAt
            ? formatTime(item.lastCareReminderAt)
            : "-";
        }
        if (this.moduleKey === "classes")
          item.statusLabel = statusText("class", item.status);
        if (this.moduleKey === "attendance") {
          item.statusLabel = statusText(
            "attendance",
            item.status === "checked_out" ? "checked_in" : item.status
          );
          item.checkIn = item.checkInTime
            ? formatTime(item.checkInTime)
            : "--:--";
        }
        if (this.moduleKey === "leaves") {
          item.statusLabel = statusText("leave", item.status);
          item.range =
            item.endDate && item.endDate !== item.startDate
              ? `${item.startDate} 至 ${item.endDate}`
              : item.startDate;
        }
        if (this.moduleKey === "feedbacks") {
          item.statusLabel = item.published ? "已反馈" : "待反馈";
          item.mealLabel =
            {
              good: "吃得很好",
              normal: "正常",
              little: "较少",
              none: "未用餐",
            }[item.mealStatus] ||
            item.meal ||
            "--";
        }
        if (this.moduleKey === "notices") {
          item.statusLabel = statusText("notice", item.status);
          item.typeLabel =
            {
              organization: "机构公告",
              class: "班级通知",
              payment: "缴费通知",
              holiday: "放假通知",
            }[item.type] || item.type;
          item.scopeLabel =
            { all: "全体家长", class: "指定班级", student: "指定学生" }[
              item.scope
            ] || item.scope;
          item.read = `${item.readCount || 0} 人已读`;
        }
        if (this.moduleKey === "payments") {
          item.amount = formatMoney(item.receivableAmount);
          item.method =
            {
              cash: "现金",
              wechat: "微信",
              alipay: "支付宝",
              bank_transfer: "转账",
              other: "其他",
            }[item.paymentMethod] || "--";
          item.statusLabel = statusText("payment", item.status);
          item.date = item.paidAt || item.createdAt;
        }
        if (this.moduleKey === "users") {
          item.roleLabel = ROLE_LABELS[item.role] || item.role;
          item.statusLabel = statusText("user", item.status);
          item.joined = item.createdAt?.slice(0, 10) || "--";
        }
        if (this.moduleKey === "operationLogs") {
          item.createdAtLabel = item.createdAt
            ? String(item.createdAt).replace("T", " ").slice(0, 19)
            : "--";
          item.operatorName = item.operatorName || item.operatorId || "系统";
          item.actionLabel =
            operationActionLabels[item.action] || item.action || "--";
          item.resourceTypeLabel =
            resourceTypeLabels[item.resourceType] || item.resourceType || "--";
          item.resultLabel =
            item.result === "success"
              ? "成功"
              : item.result === "failed"
              ? "失败"
              : item.result || "--";
        }
        return item;
      });
    },
    resetFilters() {
      this.filters = this.createFilters();
      this.pageNo = 1;
      this.load();
    },
    search() {
      if (this.moduleKey === "attendance" && !this.filters.date)
        return this.$message.warning("请选择考勤日期");
      this.pageNo = 1;
      this.load();
    },
    changePage(page) {
      this.pageNo = page;
      this.load();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.pageNo = 1;
      this.load();
    },
    statusType(status) {
      return typeOfStatus(status);
    },
    async openForm(mode, row = {}) {
      this.editMode = mode;
      let formData = row;
      if (mode === "edit" && this.moduleKey === "feedbacks") {
        try {
          formData = await getFeedback(row.id);
        } catch (error) {
          this.$message.error(error.userMessage || "反馈内容加载失败");
          return;
        }
      }
      this.editForm = mode === "edit" ? JSON.parse(JSON.stringify(formData)) : {};
      this.dialogVisible = true;
    },
    feedbackTaskAt(subjectIndex, taskIndex) {
      const subject = (this.editForm.homeworkItems || [])[subjectIndex];
      return subject && Array.isArray(subject.contents)
        ? subject.contents[taskIndex]
        : null;
    },
    setFeedbackTaskChecked(subjectIndex, taskIndex, value) {
      const task = this.feedbackTaskAt(subjectIndex, taskIndex);
      if (task) this.$set(task, "checked", Boolean(value));
    },
    setFeedbackTaskCompletion(subjectIndex, taskIndex, value) {
      const task = this.feedbackTaskAt(subjectIndex, taskIndex);
      if (!task) return;
      this.$set(task, "completionStatus", value);
      this.$set(task, "completed", value === "completed");
      this.$set(task, "status", value);
    },
    setFeedbackSubjectComment(subjectIndex, value) {
      const subject = (this.editForm.homeworkItems || [])[subjectIndex];
      if (subject) this.$set(subject, "comment", value);
    },
    async submitForm() {
      const required = this.visibleFormFields.find(
        (field) =>
          field.required &&
          (this.editForm[field.key] === "" ||
            this.editForm[field.key] === undefined ||
            this.editForm[field.key] === null)
      );
      if (required) return this.$message.warning(`请填写${required.label}`);
      this.submitting = true;
      try {
        let result;
        const row = { ...this.editForm };
        if (this.moduleKey === "students")
          result =
            this.editMode === "add"
              ? await createStudent(row)
              : await updateStudent(row.id, row);
        else if (this.moduleKey === "classes")
          result =
            this.editMode === "add"
              ? await createClass(row)
              : await updateClass(row.id, row);
        else if (this.moduleKey === "attendance")
          result =
            this.editMode === "add"
              ? await createAttendance(row)
              : await updateAttendance(row.id, row);
        else if (this.moduleKey === "leaves") result = await createLeave(row);
        else if (this.moduleKey === "feedbacks")
          result = await saveFeedback(
            this.editMode === "edit" ? row.id : null,
            row
          );
        else if (this.moduleKey === "notices")
          result = await saveNotice(
            this.editMode === "edit" ? row.id : null,
            row
          );
        else if (this.moduleKey === "payments")
          result = await savePayment(this.editMode === "edit" ? row.id : null, {
            ...row,
            receivableAmount: toCents(row.amount),
          });
        else if (this.moduleKey === "users")
          result = await saveUser(
            this.editMode === "edit" ? row.id : null,
            row
          );
        this.dialogVisible = false;
        await this.load();
        this.$message.success("保存成功");
        return result;
      } catch (error) {
        this.$message.error(error.userMessage || "保存失败");
      } finally {
        this.submitting = false;
      }
    },
    async attendance(row, status) {
      try {
        await checkIn({ studentId: row.studentId, date: row.date });
        await this.load();
        this.$message.success("考勤状态已更新");
      } catch (error) {
        this.$message.error(error.userMessage || "考勤操作失败");
      }
    },
    async batchAttendance(status) {
      const rows = this.rows.filter((row) => row.status === "not_arrived");
      if (!rows.length) return this.$message.warning("没有符合条件的考勤记录");
      try {
        await batchCheckIn({ attendanceIds: rows.map((row) => row.id) });
        await this.load();
        this.$message.success("批量考勤操作完成");
      } catch (error) {
        this.$message.error(error.userMessage || "批量操作失败");
      }
    },
    async review(row, status) {
      try {
        await this.$confirm(
          `确认${status === "approved" ? "通过" : "拒绝"}该请假申请吗？`,
          "审批确认",
          { type: status === "approved" ? "success" : "warning" }
        );
        await (status === "approved"
          ? approveLeave(row.id)
          : rejectLeave(row.id, "后台拒绝"));
        await this.load();
        this.$message.success("审批结果已保存");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "审批失败");
      }
    },
    async markLeave(row) {
      try {
        await updateAttendance(row.id, {
          status: "leave",
          remark: "后台标记请假",
        });
        await this.load();
        this.$message.success("已标记为请假");
      } catch (error) {
        this.$message.error(error.userMessage || "标记失败");
      }
    },
    async adjustPoints(row, direction) {
      try {
        const action = direction > 0 ? "加分" : "减分";
        const amountResult = await this.$prompt(
          `请输入要${action}的分值`,
          `${row.name} - ${action}`,
          { inputPattern: /^\d+$/, inputErrorMessage: "请输入正整数" }
        );
        const amount = Number(amountResult.value);
        if (!amount) return this.$message.warning("积分必须大于 0");
        const reasonResult = await this.$prompt(
          `请输入${action}原因`,
          `${row.name} - ${action}原因`,
          {
            inputValidator: (value) =>
              Boolean(String(value || "").trim()) || "请填写原因",
          }
        );
        await adjustStudentPoints(row.id, {
          delta: direction * amount,
          reason: reasonResult.value.trim(),
        });
        await this.load();
        this.$message.success(`${action}成功`);
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "积分调整失败");
      }
    },
    tableRowClassName({ row }) {
      return this.moduleKey === "students" && Number(row.remainingDays) < 5
        ? "student-days-warning"
        : "";
    },
    canSendCareDayReminder(row) {
      return this.moduleKey === "students" && Number(row.remainingDays || 0) < 5;
    },
    async adjustRemainingDays(rows) {
      if (!rows.length) return this.$message.warning("请先选择学生");
      const names = rows.map((row) => row.name).join("、");
      try {
        const deltaResult = await this.$prompt(
          "请输入调整天数，增加填正数，扣减填负数",
          rows.length > 1 ? `批量调整 ${rows.length} 名学生` : `${names} - 调整天数`,
          {
            inputPattern: /^-?\d+$/,
            inputErrorMessage: "请输入非零整数，例如 10 或 -3",
          }
        );
        const delta = Number(deltaResult.value);
        if (!Number.isInteger(delta) || delta === 0)
          return this.$message.warning("调整天数必须为非零整数");
        const reasonResult = await this.$prompt(
          "请输入本次调整原因",
          "调整原因",
          {
            inputValidator: (value) =>
              Boolean(String(value || "").trim()) || "请填写调整原因",
          }
        );
        await this.$confirm(
          `确认将${rows.length > 1 ? `${rows.length} 名学生` : names}的剩余天数调整 ${delta > 0 ? "+" : ""}${delta} 天吗？`,
          "确认调整",
          { type: "warning" }
        );
        await adjustStudentRemainingDays({
          studentIds: rows.map((row) => row.id),
          delta,
          reason: reasonResult.value.trim(),
        });
        await this.load();
        this.$message.success("剩余天数调整成功");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "剩余天数调整失败");
      }
    },
    async sendCareDayReminder(row) {
      try {
        await this.$confirm(
          `确认向 ${row.name || "该学生"} 的家长发送一次托管天数提醒吗？`,
          "发送通知",
          { type: "warning" }
        );
        await sendStudentCareDayReminder(row.id);
        await this.load();
        this.$message.success("提醒通知已发送");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "发送提醒失败");
      }
    },
    async batchLeaveStudents() {
      if (!this.selection.length) return this.$message.warning("请先选择学生");
      const date = new Date();
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      const today = date.toISOString().slice(0, 10);
      try {
        await this.$confirm(`确认将选中的 ${this.selection.length} 名学生标记为今天请假吗？`, "批量请假", { type: "warning" });
        await Promise.all(this.selection.map(row => createLeave({ studentId: row.id, startDate: today, endDate: today, type: "other", reason: "后台批量登记请假", status: "approved" })));
        await this.load();
        this.$message.success("批量请假成功");
      } catch (error) {
        if (error !== "cancel") this.$message.error(error.userMessage || "批量请假失败");
      }
    },
    async batchSend() {
      if (!this.selection.length)
        return this.$message.warning("请先选择要发送的学生");
      try {
        await Promise.all(this.selection.map((row) => publishFeedback(row.id)));
        await this.load();
        this.$message.success("反馈已发送给家长");
      } catch (error) {
        this.$message.error(error.userMessage || "发送失败");
      }
    },
    async publishNoticeRow(row) {
      try {
        await publishNotice(row.id);
        await this.load();
        this.$message.success("通知已发布");
      } catch (error) {
        this.$message.error(error.userMessage || "发布失败");
      }
    },
    async confirmPaymentRow(row) {
      try {
        await this.$confirm(
          `确认收到 ${row.studentName} 的 ${row.amount} 吗？`,
          "确认收款",
          { type: "warning" }
        );
        await confirmPayment(row.id, {
          receivedAmount: row.receivableAmount,
          paymentMethod: "other",
        });
        await this.load();
        this.$message.success("收款已确认");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "收款确认失败");
      }
    },
    async cancelPaymentRow(row) {
      try {
        await this.$confirm("确认取消该收费记录吗？", "操作确认", {
          type: "warning",
        });
        await cancelPayment(row.id);
        await this.load();
        this.$message.success("收费记录已取消");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "取消失败");
      }
    },
    async refundPaymentRow(row) {
      try {
        const result = await this.$prompt("请输入退款原因", "确认退款", {
          inputValidator: (value) => Boolean(value) || "请输入退款原因",
        });
        await refundPayment(row.id, {
          refundAmount: row.receivedAmount,
          reason: result.value,
        });
        await this.load();
        this.$message.success("退款状态已更新");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "退款失败");
      }
    },
    async dangerAction(row, action) {
      try {
        await this.$confirm(
          `确认${action}${row.name || row.title}吗？`,
          "操作确认",
          { type: "warning" }
        );
        if (action === "停托")
          await updateStudentStatus(row.id, { status: "suspended" });
        if (action === "撤回") await revokeNotice(row.id);
        if (action === "停用")
          await updateClass(row.id, { status: "disabled" });
        await this.load();
        this.$message.success(`${action}成功`);
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || `${action}失败`);
      }
    },
    async restoreStudent(row) {
      try {
        const result = await this.$prompt(
          `请输入${row.name || "该学生"}复托后的剩余晚托天数`,
          "学生复托",
          {
            inputPattern: /^[1-9]\d*$/,
            inputErrorMessage: "剩余晚托天数必须为大于 0 的整数",
            inputPlaceholder: "例如：30",
          }
        );
        await updateStudentStatus(row.id, {
          status: "active",
          remainingDays: Number(result.value),
          reason: "复托",
        });
        await this.load();
        this.$message.success("复托成功");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "复托失败");
      }
    },
    async toggleUser(row) {
      try {
        await updateUserStatus(
          row.id,
          row.status === "active" ? "disabled" : "active"
        );
        await this.load();
        this.$message.success("账号状态已更新");
      } catch (error) {
        this.$message.error(error.userMessage || "账号状态更新失败");
      }
    },
    async resetPassword(row) {
      try {
        await this.$confirm(`确认重置 ${row.name} 的登录密码吗？`, "重置密码", {
          type: "warning",
        });
        const result = await this.$prompt(
          "请输入新密码（至少 6 位）",
          "设置新密码",
          {
            inputType: "password",
            inputValidator: (value) =>
              value && value.length >= 6 ? true : "密码至少 6 位",
          }
        );
        await resetUserPassword(row.id, result.value);
        this.$message.success("密码已重置，请通过安全渠道通知员工");
      } catch (error) {
        if (error !== "cancel")
          this.$message.error(error.userMessage || "重置失败");
      }
    },
    classCommand(command, row) {
      if (command === "edit") this.openForm("edit", row);
      else if (command === "disable") this.dangerAction(row, "停用");
      else if (command === "delete") this.deleteRow(row);
    },
    async deleteRow(row) {
      const labels = { students: "学生", classes: "班级", users: "员工" };
      const label = labels[this.moduleKey] || "记录";
      try {
        await this.$confirm(
          `确认删除${label}“${row.name || row.title}”吗？删除后将不再出现在业务列表中，历史记录仍会保留。`,
          `删除${label}`,
          { type: "warning", confirmButtonText: "确认删除", cancelButtonText: "取消" }
        );
        if (this.moduleKey === "students") await deleteStudent(row.id);
        else if (this.moduleKey === "classes") await deleteClass(row.id);
        else if (this.moduleKey === "users") await deleteUser(row.id);
        if (this.rows.length === 1 && this.pageNo > 1) this.pageNo -= 1;
        await this.load();
        this.$message.success(`${label}已删除`);
      } catch (error) {
        if (error !== "cancel") this.$message.error(error.userMessage || `${label}删除失败`);
      }
    },
    viewPickupCard(row) {
      this.pickupCardUrl = row.pickupCardUrl || "";
      this.pickupCardVisible = true;
    },
    async openDetail(row) {
      this.detailRow = { ...row };
      this.detailVisible = true;
      if (this.moduleKey !== "feedbacks") return;
      this.detailLoading = true;
      try {
        this.detailRow = await getFeedback(row.id);
      } catch (error) {
        this.$message.error(error.userMessage || "反馈详情加载失败");
      } finally {
        this.detailLoading = false;
      }
    },
    async cancelLeaveRow(row) {
      try {
        await this.$confirm(`确认撤销${row.studentName || row.name}的请假吗？`, "撤销请假", { type: "warning" });
        await cancelLeave(row.id, "后台撤销请假");
        await this.load();
        this.$message.success("请假已撤销");
      } catch (error) {
        if (error !== "cancel") this.$message.error(error.userMessage || "撤销失败");
      }
    },
    exportData() {
      const csv = [
        this.page.columns.map((item) => item.label).join(","),
        ...this.rows.map((row) =>
          this.page.columns
            .map((item) => JSON.stringify(row[item.prop] ?? ""))
            .join(",")
        ),
      ].join("\n");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(
        new Blob([`\ufeff${csv}`], { type: "text/csv;charset=utf-8" })
      );
      const exportDate = this.moduleKey === "leaves" && this.filters.date
        ? this.filters.date
        : "--";
      link.download = this.moduleKey === "leaves" ? `${exportDate}请假记录.csv` : `${this.page.title}.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
};
</script>
